import React from 'react';
import { AuthContext } from '@app/providers';
import Header from '@app/components/header';
import LoginHeader from '@app/components/login-header';

export default function Layout() {
  const { userInfo }: any = React.useContext(AuthContext);
  const emailVerified =
    userInfo &&
    userInfo.emailVerification &&
    userInfo.emailVerification.completed;

  if (userInfo && emailVerified) {
    return <Header />;
  }
  return <LoginHeader />;
}
